import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';

import { EAction } from '~/src/features/internetV2/constants/actions';
import { TArticle } from '~/src/features/internetV2/store/reducer';
import { IAction } from '~/src/store';

const setAnswer = (payload: TArticle): IAction<EAction.ToggleAnswer, TArticle> => {
    const { isOpen, question } = payload;

    if (!isOpen) {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'internet',
            action: 'open_faq',
            label: `name:${question}`,
        });
    }

    return {
        type: EAction.ToggleAnswer,
        payload,
    };
};

export default setAnswer;
